// extracted by mini-css-extract-plugin
module.exports = {"tag":"index_tag__3KUwU","version":"index_version__AtPzN","img":"index_img__3ZwCj","spin":"index_spin__3VR3h"};